import { inject, PLATFORM_ID } from "@angular/core";
import { FirebaseService } from "./firebase/firebase.service";
import { SessionService } from "./session/session.service";
import { isPlatformServer } from "@angular/common";

const initializableServices = {
  firebase: () => inject(FirebaseService),
  session: () => inject(SessionService),
};

type InitializableServices = typeof initializableServices;

export function initializeServices(): void {
  const isServer = isPlatformServer(inject(PLATFORM_ID));
  if (isServer) {
    initializeServer(initializableServices);
  } else {
    initializeClient(initializableServices);
  }
}

function initializeServer(services: InitializableServices): void {
  services.session().initServerSide();
}

function initializeClient(services: InitializableServices): void {
  services.firebase().init();
  services.session().initClientSide();
}
